<template>
<div class="animated fadeIn">

  <b-card no-body>
    <b-card-body>
      <b-row>
        <b-col lg="6">
          <b-form-group label="From" label-cols-sm="4" label-cols-lg="3">
            <v-date-picker :formats='dateformats' v-model="fromDate" :input-props='{ class: "form-control" }' show-caps>
            </v-date-picker>
          </b-form-group>

        </b-col>
        <b-col lg="6">
          <b-form-group label="To" label-cols-sm="4" label-cols-lg="3">
            <v-date-picker :formats='dateformats' v-model="toDate" :input-props='{ class: "form-control" }' show-caps>
            </v-date-picker>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12">
          <b-button variant="primary" class="pull-right" @click="search" :disabled="fromDate > toDate">
            Search
          </b-button>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>

  <b-card no-body>
    <b-card-body>
    <b-row>
      <b-col lg="12">
     <b-button variant="primary" class="pull-left" @click="print" :disabled="visitors.length <= 0">
      Export To CSV
    </b-button>
    </b-col>
    </b-row>
    <br/>
      <b-row>
      <b-col lg="12">


    <ag-grid-vue
             class="ag-theme-balham"
             id="myGrid"
             :gridOptions="gridOptions"
             :columnDefs="columns"
             :rowData="visitors">
    </ag-grid-vue>

    </b-col>
    </b-row>


    </b-card-body>
  </b-card>


</div>

</template>

<script>
import { mapState } from 'vuex'
import Vue from 'vue'
import {AgGridVue} from "ag-grid-vue";

export default {
  name: 'VisitorsReport',
  components: {
    AgGridVue
  },
  data: function() {
    return {
      fromDate: new Date(),
      toDate: new Date(),
      visitors: [],
      gridOptions : {},
      gridApi: null,
      columns : [],
      useVuex: false,
      theme: 'bootstrap4',
      template: 'default'
    }
  },
  methods: {

  search() {
      this.visitors = []
      let params = {
        from: this.formatDate(this.fromDate),
        to: this.formatDate(this.toDate)
      }
      Vue.axios.get('admin/reports/visitors-by-range', {params: params})
      .then(response => {
        this.visitors = response.data.data
        if(this.visitors.length > 0){
        this.columns = [
                  {headerName: 'Building', field: 'building', sortable: true, filter: true},
                  {headerName: 'Satsangi Name', field: 'applicant_name', sortable: true, filter: true},
                  {headerName: 'Arrival Date', field: 'arrival_date', sortable: true, filter: true},
                  {headerName: 'Departure Date', field: 'departure_date'}
              ];
        }
        else{
        this.columns = [];
        }
        this.showSuccessMsg()
      })
      .catch ( error => {
        this.showErrorMsg()
      });
    },


  print() {
     this.gridApi.exportDataAsCsv({});
  }
  },
  created () {
  },
  mounted() {
    this.gridApi = this.gridOptions.api;

  }

}


</script>
